module.exports = {"create":"Tạo Quản lý Đối tác","createDescription":"Tạo Người dùng Quản lý đối tác","success":"Quản lý Đối tác đã tạo thành công!"};